import { useWindowSize } from 'react-use'

export const useDeviceScreen = () => {
  const { width } = useWindowSize()

  return {
    isDesktop: width >= 768,
    isMobile: width < 768,
  }
}
